import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MobileCTA from "@/components/MobileCTA";
import ChatWidget from "@/components/ChatWidget";
import AuthCallback from "@/components/AuthCallback";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import WhyUsPage from "@/pages/WhyUsPage";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import GalleryPage from "@/pages/GalleryPage";
import TestimonialsPage from "@/pages/TestimonialsPage";
import QuotePage from "@/pages/QuotePage";
import ContactPage from "@/pages/ContactPage";
import PrayerRequestPage from "@/pages/PrayerRequestPage";
import BlogPage from "@/pages/BlogPage";
import BlogArticlePage from "@/pages/BlogArticlePage";
import SchedulePage from "@/pages/SchedulePage";
import MaintenancePlansPage from "@/pages/MaintenancePlansPage";
import AdminPage from "@/pages/AdminPage";
import FloatingSocials from "@/components/FloatingSocials";

let lenis = null;

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/why-choose-us" element={<WhyUsPage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/services/:slug" element={<ServiceDetailPage />} />
      <Route path="/maintenance-plans" element={<MaintenancePlansPage />} />
      <Route path="/gallery" element={<GalleryPage />} />
      <Route path="/testimonials" element={<TestimonialsPage />} />
      <Route path="/request-quote" element={<QuotePage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/prayer-requests" element={<PrayerRequestPage />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:slug" element={<BlogArticlePage />} />
      <Route path="/schedule" element={<SchedulePage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  useEffect(() => {
    lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollManager />
      <div className="min-h-screen bg-[#0A0A0C] text-[#F4EFE6] font-sans antialiased">
        <Header />
        <main className="pb-[68px] md:pb-0">
          <AppRoutes />
        </main>
        <Footer />
        <MobileCTA />
        <FloatingSocials />
        <ChatWidget />
        <Toaster position="top-center" theme="dark" />
      </div>
    </BrowserRouter>
  );
}
